import { DefaultLayout } from '../lib/layouts/layouts';
import { RouteMeta } from 'vue-router';

export const defaultMeta: RouteMeta = {
  backButton: true,
  formConfig: null,
  layoutComponent: DefaultLayout,
  layoutPageTitle: null,
  pageTitle: null,
};

export const defaultMetaMedicalRequest = {
  ...defaultMeta,
  pageTitle: 'Medical Request',
  requiresLoadedTenant: true,
};

export const defaultMetaAdminRequest = {
  ...defaultMeta,
  pageTitle: 'Admin requests',
  requiresLoadedTenant: true,
};

export const defaultNhsErrorMeta: RouteMeta = {
  nhsAppActions: {
    setBackAction: 'GO_BACK',
    goToPage: 'GO_BACK', //
    showBackNhsApp: true,
    showBackNhsAppWeb: false,
  },
};
